/**
 * @generated SignedSource<<74311ba85c0851d132d0833ad283f136>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InstagramLinkStatus = "FACEBOOK_LOGIN_EXPIRED" | "LINKED" | "UNLINKED";
import { FragmentRefs } from "relay-runtime";
export type CampaignInputSnsInfluencer$data = {
  readonly instagramLinkStatus: InstagramLinkStatus;
  readonly linkingInstagram: boolean | null;
  readonly linkingTiktok: boolean | null;
  readonly linkingTwitter: boolean | null;
  readonly profile: {
    readonly tiktokUrl: string | null;
    readonly ytChannel: string | null;
  };
  readonly tiktokOauthEnabled: boolean;
  readonly " $fragmentType": "CampaignInputSnsInfluencer";
};
export type CampaignInputSnsInfluencer$key = {
  readonly " $data"?: CampaignInputSnsInfluencer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputSnsInfluencer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignInputSnsInfluencer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingInstagram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramLinkStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTwitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTiktok",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tiktokOauthEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ytChannel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "3d7befeca8928b63396297e85072185e";

export default node;
